import React from 'react';
import { Box, Flex, Text, Image, Button, IconButton, Divider } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { Minus, Plus, Trash2, ShoppingBag } from 'lucide-react';
import { useAppContext } from '../context/AppContext';
export const Cart: React.FC = () => {
  const {
    cart,
    updateCartQuantity,
    removeFromCart
  } = useAppContext();
  const navigate = useNavigate();
  const totalMRP = cart.reduce((sum, item) => sum + item.price * item.quantity, 0);
  const totalDiscount = cart.reduce((sum, item) => sum + (item.price - item.discountPrice) * item.quantity, 0);
  const finalAmount = totalMRP - totalDiscount;
  if (cart.length === 0) {
    return <Flex direction="column" align="center" justify="center" minH="70vh" p={4} bg="white" className="animate-fade-in" data-id="element-378">
        <Box className="animate-float" mb={4} data-id="element-379">
          <Box bg="gray.100" p={5} borderRadius="full" data-id="element-380">
            <ShoppingBag size={48} color="var(--chakra-colors-gray-400)" data-id="element-381" />
          </Box>
        </Box>
        <Text fontSize="lg" fontWeight="700" color="gray.700" data-id="element-382">
          Your cart is empty
        </Text>
        <Text mt={2} fontSize="sm" color="gray.400" textAlign="center" data-id="element-383">
          Add some stylish clothing to get started
        </Text>
        <Button mt={6} bg="brand.500" color="white" borderRadius="12px" px={8} _hover={{
        bg: 'brand.600'
      }} onClick={() => navigate('/products')} data-id="element-384">
          Shop Now
        </Button>
      </Flex>;
  }
  return <Box bg="gray.50" minH="100%" pb="80px" className="animate-fade-in" data-id="element-385">
      <Box px={4} pt={4} data-id="element-386">
        <Text fontSize="lg" fontWeight="700" color="gray.800" mb={3} data-id="element-387">
          Cart ({cart.length})
        </Text>
      </Box>
      <Box px={3} data-id="element-388">
        {cart.map((item, idx) => <Box key={`${item.id}-${item.selectedSize}-${item.selectedColor}`} bg="white" p={3} mb={2} borderRadius="14px" shadow="sm" className="animate-slide-up" style={{
        animationDelay: `${idx * 0.05}s`
      }} data-id="element-389">
            <Flex gap={3} data-id="element-390">
              <Image src={item.images[0]} alt={item.title} w="80px" h="80px" objectFit="cover" borderRadius="12px" data-id="element-391" />
              <Box flex={1} data-id="element-392">
                <Text fontSize="sm" fontWeight="600" noOfLines={2} color="gray.800" data-id="element-393">
                  {item.title}
                </Text>
                {(item.selectedSize || item.selectedColor) && <Text fontSize="10px" color="gray.400" mt={0.5} data-id="element-394">
                    {item.selectedSize && `Size: ${item.selectedSize}`}{' '}
                    {item.selectedColor && `· ${item.selectedColor}`}
                  </Text>}
                <Flex align="baseline" gap={2} mt={1} data-id="element-395">
                  <Text fontSize="md" fontWeight="800" data-id="element-396">
                    ₹{item.discountPrice}
                  </Text>
                  <Text fontSize="xs" color="gray.400" textDecoration="line-through" data-id="element-397">
                    ₹{item.price}
                  </Text>
                </Flex>
              </Box>
            </Flex>
            <Divider my={2} data-id="element-398" />
            <Flex justify="space-between" align="center" data-id="element-399">
              <Flex align="center" borderWidth="1px" borderRadius="10px" borderColor="gray.200" data-id="element-400">
                <IconButton aria-label="Decrease" icon={<Minus size={14} data-id="element-402" />} size="sm" variant="ghost" onClick={() => updateCartQuantity(item.id, item.quantity - 1)} data-id="element-401" />
                <Text px={3} fontSize="sm" fontWeight="700" data-id="element-403">
                  {item.quantity}
                </Text>
                <IconButton aria-label="Increase" icon={<Plus size={14} data-id="element-405" />} size="sm" variant="ghost" onClick={() => updateCartQuantity(item.id, item.quantity + 1)} data-id="element-404" />
              </Flex>
              <Button size="sm" variant="ghost" color="red.400" leftIcon={<Trash2 size={14} data-id="element-407" />} onClick={() => removeFromCart(item.id)} fontSize="xs" data-id="element-406">
                Remove
              </Button>
            </Flex>
          </Box>)}
      </Box>

      <Box bg="white" p={4} mt={2} mx={3} borderRadius="14px" shadow="sm" mb={4} data-id="element-408">
        <Text fontWeight="700" mb={3} fontSize="sm" color="gray.800" data-id="element-409">
          Price Details
        </Text>
        <Flex justify="space-between" mb={2} data-id="element-410">
          <Text fontSize="xs" color="gray.500" data-id="element-411">
            Price ({cart.length} items)
          </Text>
          <Text fontSize="xs" data-id="element-412">₹{totalMRP}</Text>
        </Flex>
        <Flex justify="space-between" mb={2} data-id="element-413">
          <Text fontSize="xs" color="gray.500" data-id="element-414">
            Discount
          </Text>
          <Text fontSize="xs" color="green.500" data-id="element-415">
            -₹{totalDiscount}
          </Text>
        </Flex>
        <Flex justify="space-between" mb={3} data-id="element-416">
          <Text fontSize="xs" color="gray.500" data-id="element-417">
            Delivery
          </Text>
          <Text fontSize="xs" color="green.500" data-id="element-418">
            Free
          </Text>
        </Flex>
        <Divider mb={3} data-id="element-419" />
        <Flex justify="space-between" data-id="element-420">
          <Text fontWeight="800" data-id="element-421">Total</Text>
          <Text fontWeight="800" fontSize="lg" data-id="element-422">
            ₹{finalAmount}
          </Text>
        </Flex>
        <Text fontSize="10px" color="green.500" fontWeight="600" mt={1} data-id="element-423">
          You save ₹{totalDiscount}
        </Text>
      </Box>

      <Box position="fixed" bottom="72px" w="full" maxW="480px" bg="white" p={3} shadow="0 -4px 20px rgba(0,0,0,0.08)" zIndex={10} data-id="element-424">
        <Flex justify="space-between" align="center" data-id="element-425">
          <Box data-id="element-426">
            <Text fontSize="10px" color="gray.400" data-id="element-427">
              Total
            </Text>
            <Text fontSize="lg" fontWeight="800" data-id="element-428">
              ₹{finalAmount}
            </Text>
          </Box>
          <Button bg="brand.500" color="white" size="lg" px={8} borderRadius="12px" _hover={{
          bg: 'brand.600'
        }} onClick={() => navigate('/checkout')} fontWeight="700" data-id="element-429">
            Place Order
          </Button>
        </Flex>
      </Box>
    </Box>;
};